import { ResultsCountMessage } from '../components/results/results-count-msg';
import { ResultsProps } from '../state-helpers/site-settings-props';

export function getResultsText(
    totalResults: number,
    pageResults: number,
    pageSize: number,
    currentPage: number)
{

    let resultsText: string;

    if (totalResults == 0 || (totalResults <= pageSize * (currentPage - 1))) {
        // Show Zero Results message if no results or out of range
      resultsText = 'Showing 0 results.';
    } else {
        let rangeFirst = ((currentPage - 1) * pageSize) + 1;
        let rangeLast = totalResults < pageSize ? totalResults : rangeFirst + pageResults - 1;
        let rangeStr = (rangeFirst == rangeLast) ? rangeFirst.toString() : `${rangeFirst.toString()} - ${rangeLast.toString()}`;
        resultsText = "Showing " + rangeStr + " of " + totalResults.toString();
    }

    return resultsText;
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/global/actions/results-count.ts